import { controls } from "../../controls";

const rp1003= {
  label: "MOU 3",
  pageLabel: "MOU 3",
  starting: true,
  url: "rp1003",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [  
   
    ...controls.displayText({tab: "filter",label: "From Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"from_date",width:"col-sm-2"}),

    ...controls.displayText({tab: "filter",label: "",width:"col-sm-2 "}),

    ...controls.displayText({tab: "filter",label: "To Date",star:true,width:"col-sm-2 "}),
    ...controls.magicDate({tab: "filter",isRequired:true,name:"to_date",width:"col-sm-2"}),
        
   ...controls.displayText({tab: "filter",label: "",width:"col-sm-2"}),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-2" }),
    ...controls.perPage({ tab: 'filter'}),
  ],

  //form: [
  //  ...controls.displayText({ label: "Crop Type Code", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //  ...controls.displayText({ label: "Crop Type Desc", width: "col-sm-1", star: true }),
  //  ...controls.text({ name: "crop_type_display", isRequired: true }),
  //  ...controls.displayText({ width: "col-sm-3" }),

  //],
  form:[],

  history: {
    perPage: 10,
    reportHeader: "YIELD ON ASSETS",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [
        {
            Header:"Items",
            accessor:"items",
            rwidth:"*"
        },
        {
            Header:"Amount",
            accessor:"amount",
            type:"currency",
            rwidth:"*"
        },
        {
            Header:"Relative Share%",
            accessor:"relative_share_%",
            rwidth:"*"
        },
        {
            Header:"Earning Per 100 RS.",
            accessor:"earning_per_100_rs.",
            type:"currency",
            rwidth:"*"
        },
        {
            Header:"Weighted Average",
            accessor:"weighted_average",
            type:"currency",
            rwidth:"*"
        }
            
    ]
  }
};

export default rp1003;